export function isMobile() {
    return Math.max(document.documentElement.clientWidth, window.innerWidth) < 768 ? true : false;
}

export function isTablet() {
    return Math.max(document.documentElement.clientWidth, window.innerWidth) < 992 ? true : false;
}

export function isAndroid() {
    return navigator.userAgent.match(/Android/i);
}

export function isBlackberry() {
    return navigator.userAgent.match(/BlackBerry/i);
}

export function isIos() {
    return navigator.userAgent.match(/iPhone|iPad|iPod/i);
}

export function isIemobile() {
    return navigator.userAgent.match(/IEMobile/i);
}

export function isOpera() {
    return navigator.userAgent.match(/Opera Mini/i);
}

export function isTouch() {
    return navigator.maxTouchPoints > 0 || (navigator as any).msMaxTouchPoints > 0;
}

export function isAny() {
    return isMobile() || isTablet() || isAndroid() || isBlackberry() || isIos() || isIemobile() || isOpera();
}
